export class SingletonSharedData {
    constructor() {
        this.currentStatus = "Logout";
        this.userName = "";
        this.userId = 0;
        this.userExt = 0;
        this.dataCall = {};
        this.lastDataCall = {};
        this.unavailables = {};
        this.callsOnQueue = [];
    }
    static setCurrentStatus(currentStatus) {
        this.currentStatus = currentStatus;
    }
    static getCurrentStatus() {
        return this.currentStatus;
    }
    static setUserName(userName) {
        this.userName = userName;
    }
    static getUserName() {
        return this.userName;
    }
    static setUserId(userId) {
        this.userId = userId;
    }
    static getUserId() {
        return this.userId;
    }
    static setUserExt(userExt) {
        this.userExt = userExt;
    }
    static getUserExt() {
        return this.userExt;
    }
    static setDataCall(dataCall) {
        this.dataCall = dataCall;
    }
    static getDataCall() {
        return this.dataCall;
    }
    static setLastDataCall(lastDataCall) {
        this.lastDataCall = lastDataCall;
    }
    static getLastDataCall() {
        return this.lastDataCall;
    }
    static setUnavailables(unavailables) {
        this.unavailables = unavailables;
    }
    static isNotReadyAvailable(unavailableID) {
        let available=false;
        let unavailable=this.unavailables.find((unavailable)=>unavailable.TypeNotReadyId===parseInt(unavailableID));
        if (unavailable && unavailable.NumberOfEvents != '0') {
            available=true;
        }
        return available;
    }
    static clear() {
        this.currentStatus = "Logout";
        this.userName = "";
        this.userId = 0;
        this.userExt = 0;
        this.dataCall = {};
        this.lastDataCall = {};
        this.callsOnQueue = [];
    }
    static setCallsOnQueue(callonqueue) {
        this.callsOnQueue = callonqueue;
    }
    static getCallsOnQueue() {
        if (this.callsOnQueue  === undefined)
            return [];
        else
            return this.callsOnQueue;
    }
}


// WEBPACK FOOTER //
// ./src/Singleton/SingletonSharedData.js